import { useEffect, useState } from "react";

// Below 768px the app renders the mobile shell; 768px and up keeps the
// existing desktop layout. Listens to the media query so rotating or
// resizing switches live.
const QUERY = "(max-width: 767px)";

export default function useIsMobile() {
  const get = () => typeof window !== "undefined" && !!window.matchMedia?.(QUERY).matches;
  const [isMobile, setIsMobile] = useState(get);
  useEffect(() => {
    const mq = window.matchMedia?.(QUERY);
    if (!mq) return undefined;
    const onChange = () => setIsMobile(mq.matches);
    onChange();
    mq.addEventListener ? mq.addEventListener("change", onChange) : mq.addListener(onChange);
    return () => (mq.removeEventListener ? mq.removeEventListener("change", onChange) : mq.removeListener(onChange));
  }, []);
  return isMobile;
}
